import { ReactComponent as SoundCloudColorLight } from 'fym-shared/src/music-services/assets/images/soundcloud-color-light.svg';
import { ReactComponent as SoundCloudColorDark } from 'fym-shared/src/music-services/assets/images/soundcloud-color-dark.svg';
import { ReactComponent as SoundCloudColorLightPadding } from 'fym-shared/src/music-services/assets/images/soundcloud-color-light-padding.svg';
import { ReactComponent as SoundCloudColorDarkPadding } from 'fym-shared/src/music-services/assets/images/soundcloud-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const soundCloudImages: MusicServiceImages = {
  logoColor: {
    light: SoundCloudColorLight,
    dark: SoundCloudColorDark,
  },
  logoColorPadding: {
    light: SoundCloudColorLightPadding,
    dark: SoundCloudColorDarkPadding,
  },
};
